import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './VerifyOrganizerEmail.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const VerifyOrganizerEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/organizer-applications/verify-email/${token}`
      );
      
      setStatus('success');
      setMessage(response.data.message);
      
      // Redirect to profile after 3 seconds
      setTimeout(() => {
        navigate('/deltaker/profil');
      }, 3000);
    } catch (error: any) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Kunne ikke verifisere e-post');
    }
  };

  return (
    <div className="verify-organizer-email-page">
      <div className="verify-container">
        {status === 'loading' && (
          <>
            <div className="loading-spinner"></div>
            <h1>Verifiserer e-post...</h1>
            <p>Vennligst vent mens vi verifiserer e-postadressen din.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h1>E-post verifisert!</h1>
            <p>{message}</p>
            <p>Din arrangørsøknad vil nå bli behandlet av en administrator.</p>
            <p className="redirect-notice">Du blir sendt til din profil om kort tid...</p>
            <Link to="/deltaker/profil" className="btn btn-primary">
              Gå til Min Profil
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="error-icon">✗</div>
            <h1>Verifisering feilet</h1>
            <p>{message}</p>
            <p>Lenken kan være utløpt eller ugyldig. Vennligst prøv å sende inn søknaden på nytt.</p>
            <div className="action-buttons">
              <Link to="/deltaker/profil" className="btn btn-secondary">
                Tilbake til Min Profil
              </Link>
              <Link to="/bli-arrangor" className="btn btn-primary">
                Ny søknad
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyOrganizerEmail;
